export const animateCoverImage = (selector) => {
  const coverImg = document.querySelector(selector);

  if (!coverImg) {
    return;
  }

  const coverImgHeight = coverImg.offsetHeight;

  requestAnimationFrame(() => {
    if (window.scrollY < coverImgHeight) {
      coverImg.style.zIndex = 'initial';
      coverImg.style.transform = `translate3d(0, -${window.scrollY / 2}px, 0)`;

      if (coverImg) {
        coverImg.style.transform = `translate3d(0, -${window.scrollY / 2}px, 0)`;
      }
    } else {
      coverImg.style.zIndex = '-100000';
    }
  });
};
